module.exports = __webpack_public_path__ + "img/logo-front-1@3x.9f9f50ad.png";